export default __webpack_public_path__ + "static/media/sports_soccer.615342e0.svg";